// extracted by mini-css-extract-plugin
export default {"Container":"HeaderGenderSportsMenu-module__Container__I2svn","Link":"HeaderGenderSportsMenu-module__Link__rL4cV"};